import type { ReactNode } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import type { PartnerProfileData } from '../../api/partner-profile.api';
import type { PartnerProfileFormValues } from './schema';
import type { PartnerSectionId } from './partner-sections';
import { IdentitySection } from './IdentitySection';
import { ServicesSection } from './ServicesSection';
import { OnlinePresenceSection } from './OnlinePresenceSection';
import { PartnerImagesSection } from './PartnerImagesSection';

export interface PartnerSectionEditProps {
  data: PartnerProfileData;
  form: UseFormReturn<PartnerProfileFormValues>;
  trackUpload: (id: string) => (isUploading: boolean) => void;
  categoryNameById: Record<string, string>;
}

/** Each side panel's fields: the same section component in `edit` mode, bound to the panel's form. */
export const PARTNER_SECTION_EDITORS: Record<
  PartnerSectionId,
  (props: PartnerSectionEditProps) => ReactNode
> = {
  about: ({ data, form }) => (
    <IdentitySection
      data={data}
      control={form.control}
      register={form.register}
      errors={form.formState.errors}
    />
  ),
  services: ({ form, categoryNameById }) => (
    <ServicesSection
      control={form.control}
      register={form.register}
      errors={form.formState.errors}
      categoryNameById={categoryNameById}
    />
  ),
  online: ({ form }) => (
    <OnlinePresenceSection register={form.register} errors={form.formState.errors} />
  ),
  images: ({ data, form, trackUpload }) => (
    <PartnerImagesSection
      data={data}
      setValue={form.setValue}
      errors={form.formState.errors}
      trackUpload={trackUpload}
    />
  ),
};
